import React, { useState, useEffect } from "react";
import { MapPin } from "lucide-react";
import VenueCard from "../../components/Venue/VenueCard";
import Header from "../../components/LandingPage/Header";
import Pagination from "../../components/LandingPage/Pagination"; 
import LoadingCircle from "../../components/Common/LoadingCircle";
import { getDataByAll } from "../../api/venueApi";

const VenueIndex = () => {
  const [datas, setDatas] = useState([]); 
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4; 

  useEffect(() => {
      window.scrollTo(0, 0);
      setLoading(true);
      getDataByAll()
        .then((res) => setDatas(res))
        .finally(() => setLoading(false));
    }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const filteredVenues = datas.filter(v => 
    v.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    v.location?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // 3. Logika Slice untuk Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredVenues.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    return (
      <section className="min-h-screen bg-slate-50/30 dark:bg-slate-950 flex flex-col items-center justify-center">
        <LoadingCircle size="lg" />
        <p className="mt-4 text-slate-400 font-mono text-[10px] uppercase tracking-widest animate-pulse">
          Retrieving Venues Data...
        </p>
      </section>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50/30 dark:bg-slate-950 pt-32 lg:pt-44 pb-20">
      <div className="max-w-[1400px] mx-auto px-6">
        <Header 
          title="Event Venues"
          subtitle="Location Directory"
          placeholder="Search venues or locations..."
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          icon={MapPin} 
        />

         {/* Main */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">
          {currentItems.length > 0 ? (
            currentItems.map((v, i) => (
              <VenueCard key={v.id || i} venue={v} index={i} />
            ))
          ) : (
            <div className="col-span-full py-20 text-center text-slate-400 font-bold uppercase tracking-widest">
              No data found.
            </div>
          )}
        </div>
        
        {/* 5. Pagination  */}
        <div className="mt-12">
          <Pagination 
            totalItems={filteredVenues.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default VenueIndex;